import React, { useEffect } from "react";
import { Box, Container, makeStyles } from "@material-ui/core";
import Page from "src/components/Page";
// import Toolbar from './Toolbar';
import View from "./View";
import Api from "../../../Api";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    background: `${Api.background.theme}`,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const SettingsPlayers = ({ socketDeclarator, room }) => {
  //console.log("index,",socketDeclarator.socketDeclarator)
  const classes = useStyles();
  // const [connected, setConnect] = useState(null)
  useEffect(() => {
    socketDeclarator.on("JointEvent", (data) => {
      if (data.success) {
        console.log("Joined User");
      } else {
        console.log("not Connected");
      }
    });
  });

  return (
    <Page className={classes.root} title="Console">
      <Container maxWidth={false}>
        {/* <Toolbar /> */}
        <Box mt={3}>
          <View socketDeclarator={socketDeclarator} room={room} />
        </Box>
      </Container>
    </Page>
  );
};

export default SettingsPlayers;
